var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-theme-provider',{attrs:{"dark":_vm.dark}},[_c('div',[_c('base-info-card',{attrs:{"title":"KEEP IN TOUCH WITH US","pace":"6"}}),_c('base-business-contact',{attrs:{"dense":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }